import SocialSSO from './SocialSSO';

export default SocialSSO;
